import { createEvent, createStore } from 'effector';

export const cmdkOpened = createEvent();
export const cmdkClosed = createEvent();
export const cmdkToggled = createEvent();
export const cmdkQueryChanged = createEvent<string>();

export const $cmdkOpen = createStore(false)
  .on(cmdkOpened, () => true)
  .on(cmdkToggled, (s) => !s)
  .reset(cmdkClosed);

export const $cmdkQuery = createStore('')
  .on(cmdkQueryChanged, (_, q) => q)
  .reset(cmdkClosed);
